module.exports = __webpack_public_path__ + "img/employees.82a0bcaf.svg";